class MyDisclosuresController {
    constructor(_, preFetchedData, dateTimeService, disclosureService, fileSaver, toastr, blobDownloadService, securityService) {
        this._ = _;
        this.formatDate = dateTimeService.formatDate;
        this.disclosureList = preFetchedData.disclosureList;
        this.disclosureList.disclosures = this._formatListData(preFetchedData.disclosureList.disclosures);
        this.statusOptions = preFetchedData.disclosureStatusOptions;
        this.filter = {
            curtinId: securityService.getAutheticatedUserId(),
            pageIndex: this.disclosureList.page,
            pageSize: this.disclosureList.pageSize,
            statusList: "",
            sortColumn: "",
            sortDirection: "Descending"
        };
        this.newFilter = this._.assign({}, this.filter, { pageIndex: 1 });
        this.disclosureService = disclosureService;       
        this.fileSaver = fileSaver;
        this.toastr = toastr;
        this.blobDownloadService = blobDownloadService;
    }

    search() {
        this.filter = this._.assign({}, this.newFilter);    
        this.getDisclosureList();        
    }

    sortPage(sortColumn) {                
        this.filter.sortColumn = sortColumn;
        this.filter.sortDirection = this.getSortDirection(this.filter.sortDirection);
        this.getDisclosureList();      
    }

    getSortDirection(sortDirection) {
        return sortDirection === "Descending" ? "Ascending" : "Descending";
    }

    getDisclosureList() {     
        this.disclosureService.getPagedDisclosures(this.filter).then((data) => {
            if (!data.error) {
                this.disclosureList = data.data;
                this.disclosureList.disclosures = this._formatListData(this.disclosureList.disclosures);
                this.filter.pageIndex = this.disclosureList.page;
                this.filter.pageSize = this.disclosureList.pageSize;
            } else {
                this.toastr.error("An error has occurred.");
            }
        });
    }

    download() {
        this.filter = this._.assign({}, this.newFilter);
        this.blobDownloadService.downloadDisclosures(this.filter).then((response) => {
            if (!response.error) {
                if (response.data) {
                    this.fileSaver.saveAs(response.data, "Disclosures.xlsx");
                }
                else {
                    this.toastr.warning("No results for filters.");
                }
            }
        });
    }

    _formatListData(disclosures) {
        return this._.map(disclosures, (disclosure) => {         
            return {
                id: disclosure.id,
                displayId: disclosure.displayId ? disclosure.displayId : 'Pending',
                type: disclosure.type,
                status: disclosure.status,
                dateSubmitted: this.formatDate(disclosure.dateSubmitted),
                path: `/coi/disclose/${disclosure.type === 'Conflict' ? 'conflictofinterest' : 'gift'}/${disclosure.status !== 'Draft' && disclosure.status !== 'Amending'? 'review/' : ''}${disclosure.id}`,
                description: disclosure.description && disclosure.description.length > 20 ? 
                    `${disclosure.description.substring(0, 20)}...` : disclosure.description
            }   
        });
    }
}

MyDisclosuresController.$inject = ['_', 'preFetchedData', 'dateTimeService', 'disclosureService', 'FileSaver', 'toastr', 'blobDownloadService', 'securityService'];

export default MyDisclosuresController;


// WEBPACK FOOTER //
// ./app/disclose/mydisclosures.controller.js